var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHkd = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7338_15643)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24.2673C18.6274 24.2673 24 18.8948 24 12.2673C24 5.63992 18.6274 0.267334 12 0.267334C5.37258 0.267334 0 5.63992 0 12.2673C0 18.8948 5.37258 24.2673 12 24.2673Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2387 9.34571C12.966 10.48 12.4815 10.2637 12.2437 11.253C10.8429 10.9162 9.98021 9.50756 10.317 8.1067C10.6537 6.70594 12.0624 5.84325 13.4632 6.18005C12.9876 8.1585 13.4827 8.33119 13.2387 9.34571Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.60395 10.1857C10.5985 10.7956 10.243 11.1897 11.1103 11.7215C10.3571 12.9497 8.75092 13.3348 7.5227 12.5817C6.29453 11.8285 5.90936 10.2223 6.66255 8.99408C8.3972 10.0578 8.71431 9.64025 9.60395 10.1857Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.28044 13.9051C10.1678 13.1476 10.4326 13.6075 11.2065 12.947C12.1419 14.0428 12.0117 15.6894 10.916 16.6248C9.82015 17.5602 8.17353 17.43 7.23828 16.3343C8.78581 15.0132 8.4867 14.5824 9.28044 13.9051Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7145 15.3596C12.2683 14.2816 12.7875 14.1718 12.3984 13.2318C13.7296 12.6809 15.2555 13.3134 15.8065 14.6446C16.3574 15.9758 15.7248 17.5016 14.3936 18.0526C13.6156 16.1725 13.1136 16.3238 12.7145 15.3596Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1627 12.5426C13.9996 12.6339 14.0555 12.1061 13.0413 12.1857C12.9287 10.7495 14.0018 9.49363 15.4381 9.38089C16.8744 9.26844 18.1302 10.3415 18.2428 11.7778C16.2141 11.9369 16.2029 12.4611 15.1627 12.5426Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7338_15643"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.267334)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHkd);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/HKD.33063ce2cec5f1d5709efa55fa5bb750.svg";